import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { UserManageModel } from "src/app/shared/models/user.model";

@Component({
  selector: "app-copy-permissions-dialog",
  templateUrl: "./copy-permissions-dialog.component.html",
})
export class CopyPermissionsDialogComponent {
  users: UserManageModel[];

  editingUser: UserManageModel;

  selectedUser: UserManageModel;

  constructor(
    public matDialogRef: MatDialogRef<CopyPermissionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.editingUser = data.user;
    this.users = data.otherUsers;
  }

  close(result: any): void {
    this.matDialogRef.close(result);
  }

  save(): void {
    if (!this.selectedUser) {
      return;
    }

    this.close(this.selectedUser);
  }
}
